import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import firebase from 'firebase/app';
import 'firebase/firestore';

const db = firebase.firestore();

export const Nav = () => {
  const [rollouts, setRollouts] = useState({});
  useEffect(() => {
    const fetchData = async () => {
      try {
        const rollouts = await db
          .collection('rollouts')
          .doc('scheduleFeature')
          .get();

        if (rollouts) {
          setRollouts({
            id: rollouts.id,
            ...rollouts.data()
          });
        }
      } catch (err) {
        console.log(err.message);
      }
    };
    fetchData();
  }, []);

  return (
    <NavContainer>
      <NavList>
        <li>
          <NavLink exact to="/">
            Home
          </NavLink>
        </li>
        <li>
          <NavLink to="/list/">List</NavLink>
        </li>
        {rollouts.id === 'scheduleFeature' && rollouts.isActive === true && (
          <li>
            <NavLink to="/schedule/">Schedule</NavLink>
          </li>
        )}
      </NavList>
    </NavContainer>
  );
};

const NavContainer = styled.nav`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  font-family: sans-serif;
`;

const NavList = styled.nav`
  display: flex;
  list-style-type: none;
  justify-content: space-between;

  li {
    width: 100%;
    text-align: center;

    &:not(:last-child) {
      a {
        border-right: 4px solid var(--theme-primary-color);
      }
    }

    a {
      background-color: #f2f2f2;
      display: block;
      padding: 30px;
      text-decoration: none;
      color: black;

      &.active {
        background-color: var(--theme-secondary-color);
        color: var(--theme-primary-color);
      }
    }
  }
`;
